import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SHeadTableCell = styled(TableCell)(() => ({
  fontWeight: 700,
}));
